import { render } from "../../templates/partner-cart-address-field.html?vue&type=template&id=bb8c8316"
import script from "./address-field.vue?vue&type=script&lang=js"
export * from "./address-field.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__